<template>
  <!--
      作者 luoyiming
      时间：2019-10-26
      描述：设置-商城设置
  -->
  <div class="product-add">
    <!--form表单-->
    <el-form size="small" ref="form" :model="form" label-width="150px">
      <!--添加门店-->
      <div class="common-form">商城设置</div>
      <el-form-item label="商城名称" :rules="[{required: true,message: ' '}]" prop="name">
        <el-input v-model="form.name" placeholder="商城名称" class="max-w460"></el-input>
      </el-form-item>
      <el-form-item label="配送方式">
        <el-checkbox-group v-model="form.checkedCities">
          <el-checkbox v-for="(item,index) in all_type" :label="item.value" :key="index">{{item.name}}</el-checkbox>
        </el-checkbox-group>
        <div class="tips">注：配送方式至少选择一个</div>
      </el-form-item>
      <el-form-item label="是否显示店铺信息">
        <div>
          <el-radio v-model="form.store_open" label="1">显示</el-radio>
          <el-radio v-model="form.store_open" label="0">关闭</el-radio>
        </div>
        <div class="tips">主要用于微信小程序过审隐藏</div>
      </el-form-item>
      <div class="common-form">日志记录</div>
      <el-form-item label="是否记录查询日志" prop="customer">
        <el-checkbox v-model="form.is_get_log">是否记录查询日志</el-checkbox>
        <div class="tips">如果记录，日志量会有点大</div>
      </el-form-item>
      <div class="common-form">物流查询api</div>
      <el-form-item label="快递100 Customer" :rules="[{required: true,message: ' '}]" prop="customer">
        <el-input v-model="form.customer" placeholder="" class="max-w460"></el-input>
        <div class="tips">用于查询物流信息,<el-link :underline="false" href="https://www.kuaidi100.com/openapi/" target="_blank"
            type="primary">快递100申请</el-link>
        </div>
      </el-form-item>
      <el-form-item label="快递100 Key" :rules="[{required: true,message: ' '}]" prop="key">
        <el-input v-model="form.key" placeholder="" class="max-w460"></el-input>
      </el-form-item>
      <div class="common-form">商户入驻设置</div>
      <el-form-item label="是否开启短信验证">
        <div>
          <el-radio v-model="form.sms_open" label="1">开启</el-radio>
          <el-radio v-model="form.sms_open" label="0">关闭</el-radio>
        </div>
      </el-form-item>
      <div class="common-form">营销基数设置</div>
      <el-form-item label="上线基准日期">
        <el-date-picker v-model="form.marketing_launch_date" type="date" value-format="yyyy-MM-dd"
          placeholder="选择上线基准日期" class="max-w460"></el-date-picker>
        <div class="tips">用于动态生成对单总数、对单总额的起始日期</div>
      </el-form-item>
      <el-form-item label="入驻商户数">
        <el-input v-model.number="form.marketing_merchant_count" placeholder="如 500" class="max-w460" type="number"></el-input>
      </el-form-item>
      <el-form-item label="覆盖城市数">
        <el-input v-model.number="form.marketing_city_count" placeholder="如 80" class="max-w460" type="number"></el-input>
      </el-form-item>
      <el-form-item label="对单总数(基数)">
        <el-input v-model.number="form.marketing_order_count_base" placeholder="如 12000" class="max-w460" type="number"></el-input>
        <div class="tips">API 将在此基础上按上线日期动态增长</div>
      </el-form-item>
      <el-form-item label="对单总额(元)(基数)">
        <el-input v-model.number="form.marketing_order_amount_wan_base" placeholder="如 180000" class="max-w460" type="number"></el-input>
        <div class="tips">单位：元。API 将结合对单总数与单笔金额动态计算</div>
      </el-form-item>
      <el-form-item label="今日撮合订单数(基数)">
      <el-input v-model.number="form.marketing_today_match_base" placeholder="如 45" class="max-w460" type="number"></el-input>
      <div class="tips">API 将在此基数上做日波动，且不超过对单总数</div>
      </el-form-item>
      <div class="common-form">平台运营设置</div>
      <el-form-item label="抽成百分比(%)" :rules="[{required: true,message: ' '}]" prop="commission_rate">
        <el-input v-model="form.commission_rate" placeholder="抽查比例" class="max-w460" type="number"
          @keyup.native="renumber($event)"></el-input>
      </el-form-item>
      <el-form-item label="商品新增是否审核">
        <div>
          <el-radio v-model="form.add_audit" label="1">是</el-radio>
          <el-radio v-model="form.add_audit" label="0">否</el-radio>
        </div>
      </el-form-item>
      <el-form-item label="商品修改是否审核">
        <div>
          <el-radio v-model="form.edit_audit" label="1">是</el-radio>
          <el-radio v-model="form.edit_audit" label="0">否</el-radio>
        </div>
      </el-form-item>
      <el-form-item label="对单开启实名">
        <div>
          <el-radio v-model="form.issue_order_realname_open" label="1">是</el-radio>
          <el-radio v-model="form.issue_order_realname_open" label="0">否</el-radio>
        </div>
        <div class="tips">开启后，发对单需先完成实名认证</div>
      </el-form-item>
      <el-form-item label="鉴定开启实名">
        <div>
          <el-radio v-model="form.appraisal_realname_open" label="1">是</el-radio>
          <el-radio v-model="form.appraisal_realname_open" label="0">否</el-radio>
        </div>
        <div class="tips">开启后，发鉴定评估需先完成实名认证</div>
      </el-form-item>
      <el-form-item label="对单-文本内容审核">
        <div>
          <el-radio v-model="form.issue_order_text_audit_open" label="1">开启</el-radio>
          <el-radio v-model="form.issue_order_text_audit_open" label="0">关闭</el-radio>
        </div>
        <div class="tips">开启后，发布/修改对单将合并请求中的文本字段送阿里云文本审核（PLUS）</div>
      </el-form-item>
      <el-form-item label="对单-图片内容审核">
        <div>
          <el-radio v-model="form.issue_order_image_audit_open" label="1">开启</el-radio>
          <el-radio v-model="form.issue_order_image_audit_open" label="0">关闭</el-radio>
        </div>
        <div class="tips">开启后，对单附件中每张图逐一审核，须全部通过；密钥同 green/realname 配置</div>
      </el-form-item>
      <el-form-item label="鉴定-文本内容审核">
        <div>
          <el-radio v-model="form.appraisal_text_audit_open" label="1">开启</el-radio>
          <el-radio v-model="form.appraisal_text_audit_open" label="0">关闭</el-radio>
        </div>
        <div class="tips">开启后，鉴定申请中的文本字段送阿里云文本审核</div>
      </el-form-item>
      <el-form-item label="鉴定-图片内容审核">
        <div>
          <el-radio v-model="form.appraisal_image_audit_open" label="1">开启</el-radio>
          <el-radio v-model="form.appraisal_image_audit_open" label="0">关闭</el-radio>
        </div>
        <div class="tips">开启后，正面/反面/侧面/磨损/附件/补充图等每张逐一审核，须全部通过</div>
      </el-form-item>
      <!-- <div class="common-form">商户图片背景</div>
      <el-form-item label="商户入驻背景" :rules="[{required: true,message: '请输入商户入驻图片'}]">
        <el-button @click="chooseImg('image')">选择图片</el-button>
        <img class="mt10" v-img-url="form.supplier_image" width="200">
      </el-form-item> -->
      <!-- <div class="common-form">政策协议</div>
      <el-form-item label="服务协议" :rules="[{required: true,message: ' '}]" prop="service">
        <el-input v-model="form.service" placeholder="" class="max-w460"></el-input>
        <div class="tips">进入app和登录、注册页面显示</el-link>
        </div>
      </el-form-item>
      <el-form-item label="隐私政策" :rules="[{required: true,message: ' '}]" prop="privacy">
        <el-input v-model="form.privacy" placeholder="" class="max-w460"></el-input>
      </el-form-item> -->
      <!--提交-->
      <div class="common-button-wrapper">
        <el-button type="primary" @click="onSubmit" :loading="loading">提交</el-button>
      </div>
    </el-form>
    <!--上传图片-->
    <Upload v-if="isupload" :isupload="isupload" :type="type" :config="{ total: 3 }" @returnImgs="returnImgsFunc">
    </Upload>

  </div>

</template>

<script>
  import SettingApi from '@/api/setting.js';
  import Upload from '@/components/file/Upload';
  import {
    formatModel
  } from '@/utils/base.js';
  export default {
    components: {
      Upload
    },
    data() {
      return {
        /*是否正在加载*/
        loading: false,
        /*form表单数据*/
        form: {
          name: '',
          customer: '',
          key: '',
          supplier_cash: '',
          operate_type: '',
          commission_rate: '',
          supplier_image: '',
          sms_open: '',
          supplier_logo: '',
          checkedCities: [],
          edit_audit: 1,
          add_audit: 1,
          is_get_log: 0,
          service: '',
          privacy: '',
          store_open: '',
          issue_order_realname_open: '1',
          appraisal_realname_open: '1',
          issue_order_text_audit_open: '0',
          issue_order_image_audit_open: '0',
          appraisal_text_audit_open: '0',
          appraisal_image_audit_open: '0',
          marketing_launch_date: '2024-03-01',
          marketing_merchant_count: 500,
          marketing_city_count: 80,
          marketing_order_count_base: 12000,
          marketing_order_amount_wan_base: 180000,
          marketing_today_match_base: 45,
        },
        all_type: [],
        type: [],
        /*是否打开图片选择*/
        isupload: false
      };
    },
    created() {
      this.getParams()
    },

    methods: {

      /*获取配置数据*/
      getParams() {
        let self = this;
        SettingApi.storeDetail({}, true).then(res => {
            let vars = res.data.vars.values;
            self.form = formatModel(self.form, vars);

            self.form.checkedCities = res.data.vars.values.delivery_type;
            // 转成整数，兼容组件
            for (let i = 0; i < self.form.checkedCities.length; i++) {
              self.$set(self.form.checkedCities, i, parseInt(self.form.checkedCities[i]));
            }
            self.type = vars.delivery_type;
            self.form.customer = vars.kuaidi100.customer;
            self.form.key = vars.kuaidi100.key;
            self.form.service = vars.policy.service;
            self.form.privacy = vars.policy.privacy;
            self.form.issue_order_realname_open = vars.issue_order_realname_open != null ? vars.issue_order_realname_open : '1';
            self.form.appraisal_realname_open = vars.appraisal_realname_open != null ? vars.appraisal_realname_open : '1';
            const legacyIssue = vars.issue_order_content_audit_open != null ? String(vars.issue_order_content_audit_open) : null;
            const legacyApp = vars.appraisal_content_audit_open != null ? String(vars.appraisal_content_audit_open) : null;
            self.form.issue_order_text_audit_open = vars.issue_order_text_audit_open != null ? String(vars.issue_order_text_audit_open) : (legacyIssue != null ? legacyIssue : '0');
            self.form.issue_order_image_audit_open = vars.issue_order_image_audit_open != null ? String(vars.issue_order_image_audit_open) : (legacyIssue != null ? legacyIssue : '0');
            self.form.appraisal_text_audit_open = vars.appraisal_text_audit_open != null ? String(vars.appraisal_text_audit_open) : (legacyApp != null ? legacyApp : '0');
            self.form.appraisal_image_audit_open = vars.appraisal_image_audit_open != null ? String(vars.appraisal_image_audit_open) : (legacyApp != null ? legacyApp : '0');
            const mb = vars.marketing_base || {};
            self.form.marketing_launch_date = mb.launch_date || '2024-03-01';
            self.form.marketing_merchant_count = mb.merchant_count != null ? mb.merchant_count : 500;
            self.form.marketing_city_count = mb.city_count != null ? mb.city_count : 80;
            self.form.marketing_order_count_base = mb.order_count_base != null ? mb.order_count_base : 12000;
            self.form.marketing_order_amount_wan_base = mb.order_amount_wan_base != null ? mb.order_amount_wan_base : 180000;
            self.form.marketing_today_match_base = mb.today_match_base != null ? mb.today_match_base : 45;
            self.all_type = res.data.all_type;
            self.loading = false;
          })
          .catch(error => {

          });
      },


      /*提交*/
      onSubmit() {
        let self = this;
        let params = this.form;
        if (params.checkedCities.length < 1) {
          self.$message({
            message: '配送方式至少选择一种！',
            type: 'warning'
          });
          return;
        }

        self.$refs.form.validate((valid) => {
          if (valid) {
            self.loading = true;
            SettingApi.editStore(params, true)
              .then(data => {
                self.loading = false;
                self.$message({
                  message: '恭喜你，商城设置成功',
                  type: 'success'
                });
                self.$router.push('/setting/store/index');
              })
              .catch(error => {
                self.loading = false;
              });
          }
        });

      },
      renumber(e) {
        var keynum = window.event ? e.keyCode : e.which;
        var keycar = String.fromCharCode(keynum);
        if (keynum == 189 || keynum == 190 || keynum == 110 || keynum == 109) {
          this.$message.warning("禁止输入小数和负数")
          e.target.value = ''
        }
      },
      /*选择图片*/
      chooseImg(e) {
        this.type = e;
        this.isupload = true;
      },

      /*关闭选择图片*/
      returnImgsFunc(e) {
        this.isupload = false;
        if (e != null && e.length > 0) {
          if (this.type == 'logo') {
            this.form.supplier_logo = e[0].file_path;
          } else if (this.type == 'image') {
            this.form.supplier_image = e[0].file_path;
          }
        }
      }
    }

  };
</script>
<style>
  .tips {
    color: #ccc;
  }

  input::-webkit-outer-spin-button,
  input::-webkit-inner-spin-button {
    -webkit-appearance: none;
  }

  input[type="number"] {
    -moz-appearance: textfield;
  }
</style>



// WEBPACK FOOTER //
// src/views/setting/store/index.vue